/* --------------------------------------------------------------------------------------
   main.component.js
   Copyright © 2018 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

export const mainComponent  = {
    template: require('./main.html'),
    controller: 'mainCtrl',
    controllerAs: 'vm'
}

export class mainCtrl {
  /*@ngInject*/
  constructor(commonService, appService, $state) {
    this.commonService = commonService
    this.appService = appService
    this.logoutalert = false
    this.$state = $state
  }
  $onInit () {
    this.commonService.setNavyBackground()
    this.user = this.appService.user.name
    setTimeout(() => $('#main-user-button').addClass('main-user-button'), 50)
  }
  logoutUser() {
    this.logoutalert = true
  }
  logoutConfirmation() {
    this.$state.go('auth');
  }
  logoutCancel() {
    this.logoutalert = false
  }
}



// WEBPACK FOOTER //
// ./src/app/components/main.component.js